import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { homeFor } from "@/lib/sections";

export default function AuthCallback() {
  const { loginWithGoogle, setUser } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    loginWithGoogle(sessionId)
      .then((u) => navigate(homeFor(u), { replace: true }))
      .catch((e) => {
        setUser(false);
        navigate("/login", { replace: true, state: { error: errMsg(e) } });
      });
  }, [location.hash, loginWithGoogle, navigate, setUser]);

  return <div className="grid min-h-screen place-items-center text-slate-500" data-testid="auth-callback">Accesso in corso...</div>;
}
